/**
 * lib/views/javascripts/proto-chrome.js — the entry module for the Proto
 * chrome on every page Proto.render() draws (lib/views/htmls/proto/
 * chrome-body.ejs, written by lib/proto/shell-chrome.js; ADR 0082 D3).
 *
 * Contents: view
 * Ontology: Code object M33C-0735 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

import { mountProtoChrome } from './proto/chrome.js';

// ── Start ────────────────────────────────────────────────────────────────
mountProtoChrome();
